import { request } from "../../api/api";

export const print = (params) => {
  return request.post(`/print/`, params);
};

export const visualInspectionReport = (params) => {
  return request.post(`/get_visual_inspection_report/`, params);
}

export const electricTestReport = (params) => {
  return request.post(`/get_electric_test_report/`, params);
}

export const finalVisualInspectionReport = (params) => {
  return request.post(`/get_final_visual_inspection_report/`, params);
}

export const getBatchGlovesTrackingDetails = (id) => {
  return request.get(`/gloves_tracking/getBatchGlovesTrackingDetails/?batch_id=${id}`);
}

export const getTunnelOvenDataWithLeaching = (id) => {
  return request.get(`/gloves_tracking/getTunnelOvenDataWithLeaching/?batch_id=${id}`);
}
export const generateGlovesTrackingReportPDF = (params) => {
  return request.post(`/generateGlovesTrackingReportPDF/`,params);
}

export const getStationThreeMachines = () => {
  return request.get(`/get_station_three_machines/`);
};

export const getAcConditioningRoomData = (searchParams) => {
  console.log("dsfmdskfnksnfkdsn",searchParams)
  let queryParams = [

    searchParams.search.binNo ? `ac_conditioning__bin_number=${searchParams.search.binNo}` : "",
    searchParams.search.batchNo
      ? `ac_conditioning__batch__batch_type
=${searchParams.search.batchNo}`
      : "",
    searchParams.search.Scre ? `ac_conditioning__batch__scre=${searchParams.search.Scre}` : "",
    searchParams.search.Class
      ? `ac_conditioning__batch__class_id__class_name=${searchParams.search.Class}`
      : "",
    searchParams.search.Size
      ? `ac_conditioning__batch__size__size_name=${searchParams.search.Size}`
      : "",
   
    searchParams.search.cycleTime
      ? `cycle_start_time=${searchParams.search.cycleTime}`
      : "",
    searchParams.search.cycleEndTime
      ? `cycle_end_time=${searchParams.search.cycleEndTime}`
      : "",

    searchParams.search.totalTime
      ? `total_time=${searchParams.search.totalTime}`
      : "",
    searchParams.search.remainingTime
      ? `remaining_time=${searchParams.search.remainingTime}`
      : "",
      searchParams.search.overTimeL
      ? `overtime=${searchParams.search.overTimeL}`
      : "",
      searchParams.search.operator
      ? `ac_conditioning__operator=${searchParams.search.operator}`
      : "",
      searchParams.search.shift
      ? `shift__shift_name=${searchParams.search.shift}`
      : "",
      searchParams.search.quantity
      ? `good=${searchParams.search.quantity}`
      : "",
      searchParams.start_datetime
      ? `start_datetime=${searchParams.start_datetime}`
      : "",
    searchParams.end_datetime
      ? `end_datetime=${searchParams.end_datetime}`
      : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `/production_line/getACConditioningRoomData/?${queryParams}&${
      searchParams.rowsPerPage ? `page_size=${searchParams.rowsPerPage}` : ""
    }&page=${searchParams.page + 1}`
  );
};